import { customerValidationSchema } from './steps/customerForm/validation';
import { vehicleValidationSchema } from './steps/vehicleForm/validation';

export const validationSchemas = {
  vehicle: vehicleValidationSchema,
  customer: customerValidationSchema,
  service: vehicleValidationSchema,
  checklist: vehicleValidationSchema,
};
